<template>
  <div>
    <el-upload
      class="upload-demo"
      drag
      action="*"
      :http-request="httpRequest"
      :before-remove="beforeRemove"
      :on-success="handleSuccess"
      :file-list="fileList"
      multiple>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Drop files here or <em>click to upload</em></div>
    </el-upload>
  </div>
</template>

<script>
import Uploader from '@/libs/Uploader';

const ERROR = {
  PAUSE_ON_NO_FILE: 'Cannot pause a file that has not been added.',
};

export default {
  props: {
    accessKey: {
      type: String,
      required: true,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      uploader: new Uploader(this.accessKey),
    };
  },
  methods: {

    // Element UI <-> Uploader bridge function
    httpRequest(options) {
      const rawFile = options.file;

      const file = {
        status: 'ready',
        name: rawFile.name,
        size: rawFile.size,
        percentage: 0,
        uid: rawFile.uid,
        raw: rawFile,
        file: rawFile,
        path: [
          ...(this.accessKey ? [this.accessKey] : []),
          '',
        ].join('/'),
      };

      const uploadFunction = this.uploader.upload(file, (progress) => {
        options.onProgress({
          total: 1,
          loaded: progress,
          percent: progress * 100,
        }, rawFile);
      })
        // Return a file object with url inserted
        .then(fileKey =>
          ({
            ...file,
            fileKey,
          })
        );

      uploadFunction.abort = () => {
        this.uploader.cancel(this.accessKey, file.name);
      };

      uploadFunction
        .catch((error) => {
          options.onError(error);
        });

      return uploadFunction;
    },
    beforeRemove(file, fileList) {
      const isOngoingFile = !file.id || !file.file_key;

      if (isOngoingFile) {
        // Attempt to pause file upload
        return this.uploader.pause(this.accessKey, file.name)
          .catch((error) => { console.log(error); })

          .then(() =>
            this.$confirm(`Are you sure you want to stop the upload for ${file.name}?`)

              .catch((error) => {
                if (error === 'cancel') {
                  // Attempt to resume file upload
                  this.uploader.resume(this.accessKey, file.name);
                  throw error;
                }
                throw error;
              })
          );
      } else {
        return this.$confirm(`Are you sure you want to remove ${file.name}?`)
          .then(() => {
            // Ask parent to remove this file
            this.$emit('remove', file, fileList);
          });
      }
    },
    handleSuccess(response, file, fileList) {
      this.$emit('success', response, file, fileList);
    },
  },
};
</script>

<style lang="scss">
.upload-demo {
  .el-upload {
    display: block;
  }
  .el-upload-dragger {
    width: 100%;
    height: calc(100vh - 500px);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/VideoUploader/index.vue